import React from 'react';

export default function NewSweepstakes() {
  return (
    <iframe
      src="https://scribehow.com/shared/Creating_a_Sweepstakes_on_Shopify__cYk2mtlETGevFwDK992Heg"
      height="640"
      title="New Sweepstakes"
      allowFullScreen
    />
  );
}
